import React, { useState, useEffect } from "react";
import Table from "components/Table";
import { useDispatch, useSelector } from "react-redux";
import { getBroadcastList } from "store/actions";
import Columns from "../Columns";
import FadeLoader from "react-spinners/FadeLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const MessageList = ({isSuccess, setIsSuccess}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const { BROADCAST, loading, totalCount } = useSelector((state) => state.Broadcast);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [search_text, setSearch_text] = useState();
  const [message,setMessage]=useState()
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });
  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setMessage(res);
        }
      };
      dispatch(getBroadcastList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleShowEmails = (row) => {
      navigate(`${row.id}`, { state: { row } });
  };

  const handleForward = (row) => {
    navigate(`/admin/broadcast`, { state: { row } });
  }

  useEffect(() => {
    fetchData(filter);
    setcolumns(
      Columns({
        currentPage: filter?.pageNo,
        pageSize,
        handleShowEmails,
        handleForward
      })
    );
    setIsSuccess(false)
  }, [filter,isSuccess]);

  const handleTableChange = (pageNumber, newPageSize) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      {!loading && BROADCAST?.msgs?.length > 0 && (
        <Table
          data={BROADCAST?.msgs}
          columns={columns}
          setFilter={setFilter}
          handleTableChange={handleTableChange}
          totalCount={totalCount}
          filter={filter}
        />
      )}
      {!loading && BROADCAST?.length === 0 && (
        <p style={{ textAlign: "center" }}>No Broadcast Message Found</p>
      )}
       {/* {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )} */}
    </>
  );
};
export default MessageList;
